import styled from 'styled-components';
import React from 'react';

export const SelectedContrast = styled.div`
    display: flex;
    align-items: center;
    margin: 20px auto;
    justify-content: center;
    align-items: center;
`;

export const ContrastLabel = styled.p`
    text-transform: uppercase;
    font-size: 16px;
`;

export const Svg = styled.svg`
    width: 15px; 
    height: 15px; 
    display: inline-block; 
    user-select: none; 
    fill: currentcolor;
    margin-left: 5px;

    &:hover {
        cursor: pointer;
    } 
`

export const SearchWrapper = styled.div`
    margin: 20px 10px;
`;

export const CloseIcon = ({ onClick }) => (
    <Svg
        viewBox="0 0 15 15"
        onClick={onClick}
    >
        <path
            fill="#797979"
            d="M7.5 6.58L1.742.824a.4.4 0 0 0-.565 0l-.354.354a.4.4 0 0 0 0 .565L6.581 7.5.823 13.258a.4.4 0 0 0 0 .565l.354.354a.4.4 0 0 0 .565 0L7.5 8.419l5.758 5.758a.4.4 0 0 0 .565 0l.354-.354a.4.4 0 0 0 0-.565L8.419 7.5l5.758-5.758a.4.4 0 0 0 0-.565l-.354-.354a.4.4 0 0 0-.565 0L7.5 6.581z"
        >
        </path>
    </Svg>
);

export const ToggleContent = styled.span`
    font-size: 13px;
`;

export const ToggleDisplayName = styled.span`
`;

export const TogglePrice = styled.span`
    background: gainsboro;
    text-align: center;
    padding: 2.5px;
    border-radius: 4px;
    margin-left: 5px;
    font-size:13px;
    margin-top: ${props => props.marginTop};
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    height: 24px;

    &:before {
        content: '+';
        margin-left: 4px;
    }
`;


// export const ShirtPriceLabel = styled.div`
//     font-size: 24px;

//     &:after {
//         content: '\\20BD';
//         margin-left: 4px;
//         font-size: 24px;
//     }
// `;

export const HeaderComponent = styled.h2`
    font-size: 16px;
    text-transform: uppercase;
    text-align: center;
    margin: 10px;
    font-weight: normal;
`;